import React from "react";
import MidSection from "./MidSection";
import TopBrands from "./TopBrands";

const Home = () => {
  return (
    <>
      <MidSection />
      <TopBrands />
    </>
  );
};

export default Home;
